export enum EntityType {
  TEST_CASE = 'TEST_CASE',
  TEST_SUITE = 'TEST_SUITE',
  AFTER_TEST_SUITE = 'AFTER_TEST_SUITE',
  AFTER_TEST_SUITE_RESULT = 'AFTER_TEST_SUITE_RESULT',
  TEST_PLAN = 'TEST_PLAN',
  RUN_RESULT = 'RUN_RESULT',
  TEST_CASE_RESULT = 'TEST_CASE_RESULT',
  TEST_SUITE_RESULT = 'TEST_SUITE_RESULT',
  ENVIRONMENT_RESULT = 'ENVIRONMENT_RESULT',
  TEST_STEP_RETRY_RESULT = 'TEST_STEP_RETRY_RESULT',
  TEST_STEP_RESULT = 'TEST_STEP_RESULT',
  ELEMENT = 'ELEMENT',
  TEST_DEVICE_RESULT = 'TEST_DEVICE_RESULT',
  SCREENSHOT = 'SCREENSHOT',
  VISUAL_DIFFERENCE_SCREENSHOT = 'VISUAL_DIFFERENCE_SCREENSHOT',
  ACCESSIBILITY_RESULT = 'ACCESSIBILITY_RESULT',
}
